<ng-container *ngIf="recommendations$ | async as recommendations">
    <div class="relative max-w-7xl mx-auto" *ngIf="recommendations.length">
        <div class="pt-16 px-4 sm:px-6 lg:px-8">
            <kb-section-header color="sienna">Related Products</kb-section-header>
            <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6">
                <vsf-product-card
                    [product]="item"
                    *ngFor="let item of recommendations"
                ></vsf-product-card>
            </div>
        </div>
    </div>
</ng-container>
